import { combineReducers } from 'redux'
import coachesReducer from './coaches/reducers'
import usersReducer from './users/reducers'
import newUserReducer from './newUser/reducers'
import { ClinicManagementState } from '../../../types/rootStoreTypes'

export default combineReducers<ClinicManagementState>({
	coaches: coachesReducer,
	users: usersReducer,
	newUser: newUserReducer,
})
